import React  from "react";
import StickerPackTable from "./StickerPackTable";

export default function StickerManagement() {

    return (
        <div className="p-3">
            <h1 className="text-2xl font-bold mb-6">Sticker Management</h1>
            <StickerPackTable/>
        </div>
    );
}
